var map = {
	"./symbol_0.png": 74094,
	"./symbol_1.png": 19671,
	"./symbol_2.png": 61564,
	"./symbol_3.png": 44453,
	"./symbol_4.png": 77578,
	"./symbol_5.png": 16435,
	"./symbol_6.png": 70680,
	"./symbol_7.png": 91809,
	"./symbol_8.png": 72966,
	"./symbol_9.png": 11983
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87577;